export default function CourtLineDivider(){
    return(
        <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", margin: "40px 0px", width: "100%" }}>
            <div style={{
            position: "absolute",
            left: 0,
            top: "50%",
            width: "100%",
            height: "1px",
            background: "var(--black16)",
            zIndex: 1,
            transform: "translateY(-50%)"
            }} />
            {/* Centered circle */}
            <div style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: 20,
            height: 20,
            borderRadius: "50%",
            border: "1px solid var(--black16)",
            zIndex: 1
            }} />
        </div>
    )
}